import { render, staticRenderFns } from "./MapAreaSelect.vue?vue&type=template&id=453ff8c4&"
import script from "./MapAreaSelect.vue?vue&type=script&lang=js&"
export * from "./MapAreaSelect.vue?vue&type=script&lang=js&"
import style0 from "../maps/MapMixin.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports